import { ODataStoreRequestConfiguration } from '@/auth/api/config'
import { useTokenRefresh } from '@/auth/azure/azureManager'
import DateColumn from '@/components/date-column/DateColumn'
import { ObjectCodeLink } from '@/components/object-code-link/ObjectCodeLink'
import { ticket } from '@/model/qsadminapi/QsAdminApiModuleModel'
import { DumpEditorTicketsGridProps } from '@/routes/dumps/DumpEditor.types'
import { useScreenSize } from '@/themes/media-query'
import {
  Column,
  DataGrid,
  StateStoring,
  HeaderFilter,
  FilterPanel,
  FilterRow,
  Toolbar,
  Item,
  DataGridRef,
  DataGridTypes,
} from 'devextreme-react/data-grid'
import DataSource from 'devextreme/data/data_source'
import ODataStore from 'devextreme/data/odata/store'
import { ClickEvent } from 'devextreme/ui/button'
import notify from 'devextreme/ui/notify'
import { memo, useRef } from 'react'

const DumpEditorTicketsGrid = (props: DumpEditorTicketsGridProps) => {
  const { dump } = props
  const currentScreenSize = useScreenSize()

  const token = useTokenRefresh()
  const gridRef = useRef<DataGridRef>(null)

  const ticketsDataSource = new DataSource({
    store: new ODataStore({
      url: `${import.meta.env.VITE_QSADMINAPI_HOST}/ticket`,
      key: 'id',
      version: 4,
      errorHandler: (e) => {
        console.error(e.errorDetails)
        if (!e.errorDetails) return
        notify(
          {
            message: `Errore : ${e.errorDetails?.message}`,
            type: 'error',
            displayTime: 5000,
          },
          {
            position: 'bottom center',
            direction: 'up-push',
          },
        )
      },
      beforeSend: ODataStoreRequestConfiguration(token),
      deserializeDates: false,
    }),
    expand: ['assegnato', 'stato'],
    filter: [`dumps/any(a: a/id eq ${dump?.id})`],
  })

  return (
    <>
      <DataGrid
        id={`dump-tickets-grid`}
        ref={gridRef}
        dataSource={ticketsDataSource}
        noDataText="Nessun ticket associato al dump"
        showBorders={true}
        showColumnLines={true}
        focusedRowEnabled={true}
        defaultFocusedRowIndex={0}
        columnHidingEnabled={currentScreenSize.isSmall || currentScreenSize.isXSmall || currentScreenSize.isMedium}
        allowColumnReordering={true}
        allowColumnResizing={true}
        rowAlternationEnabled={true}
        wordWrapEnabled={false}
        repaintChangesOnly={true}
        width="100%"
        height={290}
      >
        <StateStoring enabled={true} type="localStorage" storageKey={'dump-tickets-grid'} savingTimeout={50} />
        <HeaderFilter visible={true} />
        <FilterPanel visible={true} />
        <FilterRow visible={true} />
        <Column
          dataField="ded_Dis"
          caption="TICKET ID"
          cellRender={(cellData: DataGridTypes.ColumnCellTemplateData) => {
            const data: ticket = cellData.row.data
            return <ObjectCodeLink url={`/tickets/${data.id}`} text={data.ded_Dis}></ObjectCodeLink>
          }}
        ></Column>
        <Column dataField="stato.nome" caption="STATO"></Column>
        <Column dataField="assegnato.fullname" caption="ASSEGNATO"></Column>
        <Toolbar>
          <Item
            location="before"
            locateInMenu="never"
            showText="inMenu"
            widget="dxButton"
            options={{
              hint: 'Refresh',
              text: 'Refresh',
              icon: 'refresh',
              onClick: (e: ClickEvent) => {
                gridRef.current?.instance().refresh()
              },
              stylingMode: 'text',
            }}
          ></Item>
        </Toolbar>
      </DataGrid>
    </>
  )
}

const DumpEditorTicketsGridMemoed = memo(DumpEditorTicketsGrid, (oldProps, newProps) => {
  return oldProps.dump?.id === newProps.dump?.id
})

export default DumpEditorTicketsGridMemoed
